<template>
  <div class="navigation-menu" :class="{ 'vertical': mode === 'vertical' }">
    <Menu :mode="mode" :active-name="activeName" @on-select="handleMenuSelect">
      <MenuItem name="home">
        <Icon type="md-home" />
        首页
      </MenuItem>
      <MenuItem name="companies">
        <Icon type="ios-briefcase" />
        公司列表
      </MenuItem>
      <MenuItem name="policies">
        <Icon type="ios-paper" />
        政策法规
      </MenuItem>
      <MenuItem name="research-reports">
        <Icon type="md-document" />
        研究报告
      </MenuItem>
      <MenuItem name="analysis">
        <Icon type="md-trending-up" />
        分析工具
      </MenuItem>
    </Menu>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'

interface Props {
  mode?: 'horizontal' | 'vertical'
}

const props = withDefaults(defineProps<Props>(), {
  mode: 'horizontal'
})

const emit = defineEmits<{
  itemClick: []
}>()

const router = useRouter()
const route = useRoute()

// 根据当前路由确定激活的菜单项
const activeName = computed(() => {
  return route.name as string
})

// 处理菜单选择
const handleMenuSelect = (name: string) => {
  emit('itemClick')
  if (name !== route.name) {
    router.push({ name })
  }
}
</script>

<style scoped>
.navigation-menu {
  background: transparent;
  padding: 0;
}

.navigation-menu :deep(.ivu-menu-horizontal) {
  background: transparent;
  border-bottom: none;
  height: 60px;
  line-height: 60px;
}

.navigation-menu :deep(.ivu-menu-vertical) {
  background: transparent;
  width: 100% !important;
}

.navigation-menu :deep(.ivu-menu-vertical .ivu-menu-item) {
  padding: 16px 24px;
  color: var(--text-secondary);
}

.navigation-menu :deep(.ivu-menu-vertical .ivu-menu-item:hover),
.navigation-menu :deep(.ivu-menu-vertical .ivu-menu-item-active) {
   background: rgba(0, 242, 96, 0.1); /* Use accent green for better contrast */
   color: var(--accent-primary);
}

.navigation-menu :deep(.ivu-menu-vertical .ivu-menu-item-selected) {
   background: rgba(0, 242, 96, 0.15); /* Slightly darker for selected */
   color: var(--accent-primary) !important;
   border-right: none; /* Remove right border */
   border-left: 2px solid var(--accent-primary); /* Add left border for active state */
}

.navigation-menu :deep(.ivu-menu-item) {
  font-size: 14px;
  color: var(--text-secondary); /* Default text color */
  transition: all 0.3s ease;
}

.navigation-menu :deep(.ivu-menu-item i) {
  margin-right: 6px;
}

/* Horizontal styles */
.navigation-menu :deep(.ivu-menu-horizontal .ivu-menu-item) {
  padding: 0 16px;
}

.navigation-menu :deep(.ivu-menu-horizontal .ivu-menu-item:hover),
.navigation-menu :deep(.ivu-menu-horizontal .ivu-menu-item-active),
.navigation-menu :deep(.ivu-menu-horizontal .ivu-menu-item-selected) {
  color: var(--accent-primary);
  border-bottom: 2px solid var(--accent-primary);
  background: transparent; 
}

/* Remove View UI default hover background if any */
.navigation-menu :deep(.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active),
.navigation-menu :deep(.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover),
.navigation-menu :deep(.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active),
.navigation-menu :deep(.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover) {
    color: var(--accent-primary);
    border-bottom: 2px solid var(--accent-primary);
}
</style>